import { render, staticRenderFns } from "./MfaSetup.vue?vue&type=template&id=b9ab5c6a&"
import script from "./MfaSetup.vue?vue&type=script&lang=js&"
export * from "./MfaSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports